<template>
  <v-dialog v-model="isOpen" persistent max-width="500">
    <v-card>
      <v-toolbar color="#0000001f">
        <v-toolbar-title>
          <v-icon left>mdi-file-check mdi-24px</v-icon>Salvar documento!
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <span
          class="text-xs-center"
        >O documento ainda é um rascunho. Antes de solicitar assinaturas ou tramitar o processo, salve-o como DocGo.</span>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          flat
          @click="$emit('keepAsDraft')"
          :loading="isSavingDraft"
          :disabled="isSavingDocGo"
        >
          Continuar como rascunho
        </v-btn>
        <v-btn
          v-show="documentToEdit.document_state === 'draft'"
          color="#4185f4"
          @click="$emit('saveAsDocument')"
          dark
          :loading="isSavingDocGo"
          :disabled="isSavingDraft"
        >
          Salvar como DOCGO
        </v-btn>
        <v-btn
          v-show="documentToEdit.document_state === 'minute_draft'"
          color="#4185f4"
          @click="$emit('saveAsDocument')"
          dark
          :loading="isSavingDocGo"
          :disabled="isSavingDraft"
        >
          Salvar como Minuta
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'save-document-dialog',
  props: ['isOpen', 'isSavingDraft', 'isSavingDocGo'],
  computed: {
    documentToEdit() {
      return this.$store.getters.documentToEdit;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/document/editor/SaveDocumentDialog.vue